import { render, staticRenderFns } from "./SelectCustomerDialog.vue?vue&type=template&id=0e957910"
import script from "./SelectCustomerDialog.vue?vue&type=script&lang=js"
export * from "./SelectCustomerDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports